/* global:
  jQuery
*/

let $ = jQuery;

// TODO: make es6 ready
// TODO: write up docs

 export function HeightMatcher( opts ) {

    if ( ! (this instanceof HeightMatcher) )
      return new HeightMatcher(opts);

  // set options / defaults
  this.opts = $.extend({}, this.defaults, ( typeof opts === 'object' ? opts : {}) );

  // ensure required opts set
  if ( !this.opts.containerSel || !this.opts.itemSel ) {
    window.console && console.log('ERR: opts.conSel and opts.itemSel are required');
    return false;
  }

  // elements
  this.$window     = $(window);
  this.$containers = $( this.opts.containerSel );

  // init (timeout to ensure calc happens 1 tick later than render)
  setTimeout(function() {

    // call calc function and pass init callback
    this.calc( this.opts.cb );

    // bind resize listener
    this.$window.on('resize', this.calc.bind(this));

  }.bind(this),1);

}

HeightMatcher.prototype = {
  constructor: HeightMatcher,
  defaults: {
    'containerSel': null,
    'itemSel': null,
    'breakpoint': 479,   //
    'padSel': null,
    'padSide': 'bottom', // supports bottom/top TODO: add both
    'cb': null,      // cb function called on first calc, gets pass $container and $items
  },
  calc: function( cb ) {

    var t = this,
      pad = 'padding-'+t.opts.padSide;

    // do nothing if no containers
    if ( !this.$containers || this.$containers.length === 0 ) {
      return false;
    }

    // handle switching/being off for breakpoint
    var isOff = this.viewport().width <= this.opts.breakpoint;

    switch ( true ) {
      case ( isOff && this.wasOff === undefined ):
        // was never on, should probably call that init callback anyway though
        this.wasOff = isOff;
        this.fireCallback( cb );
        return false;
      case ( isOff && this.wasOff === false ):
        // thats it, im switching off
        this.reset();
        this.wasOff = isOff;
        return false;
      case ( isOff && this.wasOff === true ):
        // staying off
        return false;
    }

    this.wasOff = isOff;

    // do the height matching
    this.$containers.each(function() {

      var heights = [],
        largest = 0,
        $items = $(this).find(t.opts.itemSel);

      // RESET

      // reset item heights
      $items.css('min-height','');

      // reset inner elem padding
      if ( t.opts.padSel != null ) {
        $items.find( t.opts.padSel ).css(pad, '');
      }

      // CALC HEIGHTS

      // collect list of heights
      $items.each(function() {

        var $item = $(this),
          height = $item.outerHeight();

        heights.push( height );
        // save orig height for later
        $item.data('orig-height', height);

      });

      // calculate largest
      largest = Math.max.apply(Math, heights) + 1;

      // APPLY

      // apply padding if applicatble
      if ( t.opts.padSel != null ) {

        $items.each(function(){

          var $item    = $(this),
            $padElem = $item.find( t.opts.padSel ),
            hDiff    = largest - $item.data('orig-height'),
            pDiff    = hDiff - ( $padElem.css( pad ) ? parseInt( $padElem.css( pad ) ) : 0 );

          $padElem.css( pad, pDiff );

        });

      }

      // apply min height
      $items.css('min-height', largest+'px');

      // call first calc cb
      t.fireCallback( cb );

    });
  },
  fireCallback: function (cb) {
    if ( typeof cb === 'function' ) {
      var itemSel = this.opts.itemSel;
      this.$containers.each(function(){
        var $items = $(this).find(itemSel);
        cb( $(this), $items );
      });
    }
  },
  reset: function() {
    // TODO: also reset the padding!!!
    var t = this;
    this.$containers.each(function() {
      var $items = $(this).find(t.opts.itemSel);

      // reset min-heights
      $items.css('min-height','');

      if ( t.opts.padSel != null ) {

        // reset item padding
        $items.each(function(){

          var $padElem = $(this).find( t.opts.padSel );

          $padElem.css( 'padding-'+t.opts.padSide, '' );

        });

      }
    });
  },
  viewport: function() {
        // gets viewport height and width
        // from: http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
        var e = window, a = 'inner';
        if (!('innerWidth' in window )) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
    },
}
